"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVis = require("react-vis");

var _styles = require("../../styles");

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

var _propTypes2 = require("../../constants/propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BatteryMinMaxChartInteraction = function BatteryMinMaxChartInteraction(_ref) {
  var coordinatesGroupedByTime = _ref.coordinatesGroupedByTime,
      crosshairCoordinateValues = _ref.crosshairCoordinateValues,
      endMillis = _ref.endMillis,
      setCrosshairCoordinateValues = _ref.setCrosshairCoordinateValues,
      startMillis = _ref.startMillis;
  return /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    animation: "noWobble",
    dataTestid: "battery-percentage-chart",
    height: 100,
    margin: {
      left: 70,
      right: 0
    },
    onMouseLeave: function onMouseLeave() {
      return setCrosshairCoordinateValues(null);
    },
    xDomain: [startMillis, endMillis],
    xType: "time",
    yDomain: [0, 100]
  }, /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    data: Object.values(coordinatesGroupedByTime),
    style: _styles.invisibleLineStyle,
    onNearestX: setCrosshairCoordinateValues
  }), /*#__PURE__*/_react["default"].createElement(_RecentPerformanceCrosshair.RecentPerformanceCrosshair, {
    coordinate: crosshairCoordinateValues
  }));
};

BatteryMinMaxChartInteraction.propTypes = {
  coordinatesGroupedByTime: _propTypes2.groupedCoordinatePropTypes,
  crosshairCoordinateValues: _propTypes["default"].shape({
    x: _propTypes["default"].number
  }),
  endMillis: _propTypes["default"].number.isRequired,
  setCrosshairCoordinateValues: _propTypes["default"].func.isRequired,
  startMillis: _propTypes["default"].number.isRequired
};
BatteryMinMaxChartInteraction.defaultProps = {
  coordinatesGroupedByTime: {},
  crosshairCoordinateValues: {}
};
var _default = BatteryMinMaxChartInteraction;
exports["default"] = _default;